import React, {useState} from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Box, Tab, List, ListItem, Checkbox, ListItemText, TextField,

} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {TimePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import TabContext from "@mui/lab/TabContext";

function TodoDialogEditReminders({ isOpen, onClose, eventTodo, setEventTodo }) {


    const [tabValueReminders, setTabValueReminders] = useState("daysBefore");
    const handleTabValueRemindersChange = (event, newValue) => {
        console.log("handleTabValueRemindersChange");
        setTabValueReminders(newValue);
    };


    const [reminderDaysBeforeTimeSelected, setReminderDaysBeforeTimeSelected] = useState(eventTodo.reminder_days_before_time_selected);
    const [reminderDaysBeforeArray, setReminderDaysBeforeArray] = useState(eventTodo.reminder_days_before_array || []);
    const [reminderDaysBeforeTime, setReminderDaysBeforeTime] = useState(eventTodo.reminder_days_before_time);
    const [reminderDayOfTimeSelected, setReminderDayOfTimeSelected] = useState(eventTodo.reminder_day_of_time_selected);
    const [reminderDayOfTime, setReminderDayOfTime] = useState(eventTodo.reminder_day_of_time);

    function handleReminderDaysBeforeArrayChange(event, day) {
        setReminderDaysBeforeArray((prevArray) => {
            const updatedArray = Array.isArray(prevArray) ? [...prevArray] : [];
            const newArray = updatedArray.includes(day)
                ? updatedArray.filter((d) => d !== day) // Remove if already selected
                : [...updatedArray, day]; // Add if not selected

            // If the array becomes empty, reset the reminder time
            if (newArray.length === 0) {
                setReminderDaysBeforeTime("");
            }

            return newArray;
        });
    }
    function handleReminderDaysBeforeTimeChange(time) {
        setReminderDaysBeforeTime(time.format('h:mm A'));
    }
    function handleReminderDayOfTimeChange(time) {
        setReminderDayOfTime(time.format('h:mm A'));
        setReminderDayOfTimeSelected(true);
    }
    function handleResetReminderDayOfTime() {
        setReminderDayOfTime(""); // Clear the time
        setReminderDayOfTimeSelected(false); // Unselect the reminder
    }

    function saveTodoItemReminders() {
        setEventTodo((prev) => ({
            ...prev,
            reminder_days_before_time_selected: reminderDaysBeforeTimeSelected,
            reminder_days_before_array: reminderDaysBeforeArray,
            reminder_days_before_time: reminderDaysBeforeTime,
            reminder_day_of_time_selected: reminderDayOfTimeSelected,
            reminder_day_of_time: reminderDayOfTime,
        }));
        onClose();
    }


    return (

        <Dialog open={isOpen} onClose={onClose} PaperProps={{
            sx: {
                minWidth: 350, // or '350px'
                maxWidth: 500, // optional
                width: '100%', // allows it to scale on smaller screens
            },
        }}>
            {/* Dialog Title */}
            <DialogTitle
                sx={{
                    color: '#151269',
                    textAlign: 'center',
                    backgroundColor: 'rgba(198, 226, 255, 0.8)',
                    paddingRight: '30px'
                }}
            >
                To-Do Item Reminders
            </DialogTitle>
            {/* Close Button */}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#151269',
                }}
            >
                <i className="icon-cross" style={{ fontSize: '18px', padding: '5px' }} />
            </IconButton>

            {/* Dialog Content */}
            <DialogContent sx={{ pt: 2 }}>

                <TabContext sx={{ position: 'relative' }} value={tabValueReminders}>
                    <TabList
                        centered
                        variant="fullWidth"
                        onChange={handleTabValueRemindersChange}
                        aria-label="Days Before / Day Of"
                    >
                        <Tab
                            label="Days Before"
                            value="daysBefore"
                        />
                        <Tab
                            label="Day Of"
                            value="dayOf"
                        />
                    </TabList>
                    {/* Days Before Tab Panel */}
                    <TabPanel value="daysBefore" sx={{ padding: '10px 10px 10px 10px' }}>
                        <List>
                            {[1, 2, 3, 4, 5].map((day) => (
                                <ListItem key={day} sx={{padding:'0'}}>
                                    <Checkbox
                                        checked={reminderDaysBeforeArray.includes(day)}
                                        onChange={(event) => handleReminderDaysBeforeArrayChange(event, day)}
                                    />
                                    <ListItemText primary={`${day} Day${day > 1 ? "s" : ""} Before`} />
                                </ListItem>
                            ))}
                        </List>
                        {/* Show Time Picker only if there are selected days */}
                        {reminderDaysBeforeArray.length > 0 && (
                            <TimePicker
                                size="small"
                                sx={{ width: '100%' }}
                                label="Reminder Time"
                                value={reminderDaysBeforeTime ? dayjs(reminderDaysBeforeTime, 'h:mm A') : null}
                                onChange={handleReminderDaysBeforeTimeChange}
                                renderInput={(params) => <TextField fullWidth margin="dense" {...params} />}
                            />
                        )}
                    </TabPanel>
                    {/* Day of Tab Panel */}
                    <TabPanel value="dayOf" sx={{ padding: '10px 10px 10px 10px' }}>
                        <TimePicker
                            size="small"
                            sx={{ width: '100%', marginTop: '15px' }}
                            label="Reminder Time"
                            value={reminderDayOfTime ? dayjs(reminderDayOfTime, 'h:mm A') : null}
                            onChange={handleReminderDayOfTimeChange}
                            renderInput={(params) => <TextField fullWidth margin="dense" {...params} />}
                        />

                        {/* Reset Button */}
                        <Box display="flex" justifyContent="flex-end" mt={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleResetReminderDayOfTime}
                            >
                                Reset
                            </Button>
                        </Box>

                    </TabPanel>
                </TabContext>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button onClick={onClose} sx={{ mr: 1 }}>Cancel</Button>
                    <Button variant="contained" onClick={saveTodoItemReminders}>Save</Button>
                </Box>
            </DialogContent>

        </Dialog>
    )
}

export default TodoDialogEditReminders;